import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { TreeItem, TreeView } from "@material-ui/lab";
import Typography from "@material-ui/core/Typography";
import { VERTICALS_LIST } from "../../utils/constants";
import { filterTripletsByUserLevel } from "../../utils";
import _ from "lodash";

import {
  BusinessCenter,
  SquareFoot,
  MenuBook,
  PhoneIphone,
  ExpandMore,
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    marginRight: 15,
    position: "sticky",
    top: 70,
    height: "80vh",
    overflow: "auto",
    flexGrow: 1,
  },
  vertical: {
    fontWeight: "bold",
    fontSize: 18,
    marginTop: 10,
    marginBottom: 8,
    color: "#87ad84",
  },
  verticalIcon: {
    color: "#B5CBB1",
    marginRight: 7,
  },
  macro: {
    fontWeight: "bolder",
    marginTop: 7,
    marginBottom: 5,
    color: "#87ad84",
  },
  theme: {
    fontWeight: "bolder",
    marginTop: 2,
    color: "#414141",
  },
}));

function VmtTree({
  detailedFaq,
  selectedVertical,
  triplets,
  setScrollToObject,
  setNavigationStatus,
  userData,
  vmtSelection,
}) {
  const classes = useStyles();
  const [treeData, setTreeData] = useState();
  const [treeExpanded, setTreeExpanded] = useState();

  const convertTripletsToTreeStructure = (detailedFaq) => {
    let tempTriplets = triplets;

    // if a detailed faq is showed filter the tree to show only the vertical of the selected question
    if (detailedFaq) {
      tempTriplets = tempTriplets
        .filter(function (el) {
          return el.vertical === detailedFaq._source.vertical;
        })
        .filter(function (item) {
          return item.questions !== undefined && item.questions.length > 0;
        })
        .filter(function (item) {
          return item.tema !== undefined && item.tema !== "";
        });
    } else if (selectedVertical) {
      tempTriplets = tempTriplets
        .filter(function (el) {
          return el.vertical === selectedVertical;
        })
        .filter(function (item) {
          return item.questions !== undefined && item.questions.length > 0;
        })
        .filter(function (item) {
          return item.tema !== undefined && item.tema !== "";
        });
    }

    tempTriplets = filterTripletsByUserLevel(tempTriplets, userData);
    let treeDict = {};

    const verticals = [
      ...new Set(tempTriplets.map((vertical) => vertical.vertical)),
    ];
    for (let index = 0; index < verticals.length; ++index) {
      let currentVertical = {};

      currentVertical["id"] = verticals[index];
      currentVertical["name"] = verticals[index];
      currentVertical["children"] = [];

      let selectedVertical = tempTriplets.filter(function (el) {
        return el.vertical === verticals[index];
      });

      const macrothemes = [
        ...new Set(selectedVertical.map((vertical) => vertical.macrotema)),
      ];

      for (let indexV = 0; indexV < macrothemes.length; ++indexV) {
        let currentMacro = {};
        currentMacro["id"] = macrothemes[indexV].concat(verticals[index]);
        currentMacro["name"] = macrothemes[indexV];
        currentMacro["children"] = [];
        let selectedMacrotheme = selectedVertical.filter(function (el) {
          return el.macrotema === macrothemes[indexV];
        });
        const themes = [
          ...new Set(selectedMacrotheme.map((macrotema) => macrotema.tema)),
        ];
        for (let indexT = 0; indexT < themes.length; ++indexT) {
          let currentTheme = {
            id: themes[indexT].concat(
              macrothemes[indexV].concat(verticals[index])
            ),
            name: themes[indexT],
          };
          currentMacro["children"].push(currentTheme);
        }
        currentVertical["children"].push(currentMacro);
      }
      treeDict[verticals[index]] = currentVertical;
    }
    // console.log('treeDict', treeDict);
    setTreeExpanded(treeIds(treeDict[verticals[0]]));
    return treeDict;
  };

  const treeIds = (nodes) => {
    let nodeIdList = [nodes.id];
    if (nodes.children) {
      for (let i = 0; i < nodes.children.length; i++) {
        nodeIdList.push(treeIds(nodes.children[i]));
      }
    }
    //flatten because array contains children arrays
    return [].concat(...nodeIdList);
  };

  /*Il codice contenuto da qui fino alla fine di questo commento serve unicamente ad effettuare una distinzione tra il
   click sulla voce dell'alberatura per espandere l'albero rispetto ai click per navigare a quel tema/macrotema*/
  let flag = true;
  const handleNodeSelect = (event, nodeId) => {
    //FA SCHIFO? SI
    //FUNZIONA? SI
    if (!selectedVertical) {
      if (nodeId.includes("Tecnico")) {
        vmtSelection("Tecnico");
      } else if (nodeId.includes("Professionale")) {
        vmtSelection("Professionale");
      } else if (nodeId.includes("Gestionale")) {
        vmtSelection("Gestionale / Finanziario");
      } else if (nodeId.includes("Genius")) {
        vmtSelection("Genius Lab");
      }
    }
    console.log("VmtTree selectedVertical", selectedVertical);
    if (flag === true && setScrollToObject) {
      setNavigationStatus("vertical_detail");
      console.log("handleNodeSelect", nodeId, flag);
      setScrollToObject(nodeId.concat("treeItem"));
    }
  };

  const changeFlag = () => {
    flag = false;
  };

  const changeFlagAgain = () => {
    flag = true;
  };
  //FINE COmMENTO

  const VerticalIcon = ({ id }) => {
    switch (id) {
      case "Professionale":
        return <MenuBook className={classes.verticalIcon} />;
      case "Gestionale / Finanziario":
        return <BusinessCenter className={classes.verticalIcon} />;
      case "Tecnico":
        return <SquareFoot className={classes.verticalIcon} />;
      case "Genius Lab":
        return <PhoneIphone color="primary" className={classes.verticalIcon} />;
      default:
        return null;
    }
  };

  const renderTree = (nodes) => {
    const id = nodes.id.replace(" / ", "/");
    return (
      <TreeItem
        key={nodes.id}
        nodeId={nodes.id}
        label={
          <div>
            <Typography
              variant="body1"
              className={
                nodes.children
                  ? VERTICALS_LIST.includes(id)
                    ? classes.vertical
                    : classes.macro
                  : classes.theme
              }
            >
              <VerticalIcon id={id} />
              {nodes.name}
            </Typography>
          </div>
        }
        onIconClick={changeFlag}
        onLabelClick={changeFlagAgain}
      >
        {Array.isArray(nodes.children)
          ? nodes.children.map((node) => renderTree(node))
          : null}
      </TreeItem>
    );
  };

  useEffect(
    () => {
      setTreeData(convertTripletsToTreeStructure(detailedFaq));
    },
    [] // eslint-disable-line react-hooks/exhaustive-deps
  );

  return (
    <>
      {treeData && (
        <TreeView
          className={classes.root}
          defaultCollapseIcon={<ExpandMore />}
          defaultExpandIcon={<ExpandMore />}
          defaultExpanded={treeExpanded}
          onNodeSelect={handleNodeSelect}
        >
          {Object.keys(treeData).map((k) => renderTree(treeData[k]))}
        </TreeView>
      )}
    </>
  );
}

export default React.memo(VmtTree, (props, nextProps) => {
  // Render component only when users changes
  return (
    _.isEqual(props.detailedFaq, nextProps.detailedFaq) &&
    _.isEqual(props.selectedVertical, nextProps.selectedVertical) &&
    _.isEqual(props.triplets, nextProps.triplets) &&
    _.isEqual(props.vmtSelection, nextProps.vmtSelection)
  );
});
